import {Component} from '@angular/core'

@Component({
  selector: 'cft-dashboard-card-footer',
  templateUrl: './dashboard-card-footer.component.html',
  styles: [':host { height: 100% }'],
})
export class DashboardCardFooterComponent {}
